(function ($) {
  Drupal.behaviors.beautiful_belle_quiz = {
    attach: function (context) {
      $('#belle_mod5', context).once(function () {
        var thisModuleName = 'belle_mod5';
        var triggerMod = '#belle_mod5';
        var $thismodule = $('#belle_mod5');
        // If module is called in URL, scroll to module.
        var urlHash = window.location.href.split('#')[1];

        if (urlHash === thisModuleName) {
          $('html,body').animate(
            {
              scrollTop: $thismodule.offset().top - 85
            },
            1500
          );
        }

        // Check if Content Author has specified for module
        // to fade in.
        var moduleWillFade = false;
        var hasFaded = false;

        if ($thismodule.data('scrollmagic') === 1) {
          moduleWillFade = true;
        }

        // Hide and push down the module if it is to be faded in.
        if (moduleWillFade) {
          $thismodule.addClass('hideModules');
        }

        // Handle module fade-in from CMS.
        function fadeThisModule() {
          if (hasFaded === false) {
            hasFaded = true;
            $thismodule.animate(
              {
                opacity: 1,
                paddingTop: '0'
              },
              350,
              'easeOutQuad'
            );
          } else {
            return;
          }
        }

        // QUIZ.
        var quizSections = $('.js-belle__quiz-q');
        var firstQ = $('.js-belle__quiz-q-1');
        var options = $('.js-belle__quiz-option');
        var nextBtn = $('.js-belle__quiz-btnNext');
        var ansBtn = $('.js-belle__quiz-btnAns');
        var restartBtn = $('.js-belle__quiz-restart');
        var quizSection = '.js-belle__quiz-section';
        var answerSection = '.js-belle__quiz-ansBlock';
        var option1 = 'js-belle__quiz-option1';
        var option2 = 'js-belle__quiz-option2';
        var option1Val;
        var option2Val;
        var option3Val;
        var answer;
        var direction;

        option1Val = option2Val = option3Val = 0;

        function incrementOptions($this, direction) {
          if (direction === 'decrement') {
            if ($this.hasClass(option1)) {
              option1Val--;
            } else if ($this.hasClass(option2)) {
              option2Val--;
            } else {
              option3Val--;
            }
          } else {
            if ($this.hasClass(option1)) {
              option1Val++;
            } else if ($this.hasClass(option2)) {
              option2Val++;
            } else {
              option3Val++;
            }
          }
        }

        options.on('click', function () {
          var $this = $(this);

          if ($this.hasClass('active')) {
            direction = 'decrement';
            $this.removeClass('button--dark active').addClass('button--light');
            $this.siblings('.belle__quiz-option').removeClass('inactive');
            $this.siblings('button').addClass('belle__quiz-btnInactive');
          } else {
            direction = 'increment';
            $this.removeClass('button--light').addClass('button--dark active');
            $this.siblings('.belle__quiz-option').addClass('inactive');
            $this.siblings('button').removeClass('belle__quiz-btnInactive');
          }
          incrementOptions($this, direction);
        });

        nextBtn.on('click', function () {
          $(this).closest('.js-belle__quiz-q').fadeOut().next().delay(200).fadeIn();
        });

        function getAnswer() {
          var optionClickVals = [
            {
              option: '1',
              value: option1Val
            },
            {
              option: '2',
              value: option2Val
            },
            {
              option: '3',
              value: option3Val
            }
          ];
          var maxVal = -Infinity;
          var optionResult;
          var mostlyABs = optionClickVals[0].value === 2 && optionClickVals[1].value === 2;
          var mostlyBCs = optionClickVals[1].value === 2 && optionClickVals[2].value === 2;
          var mostlyACs = optionClickVals[0].value === 2 && optionClickVals[2].value === 2;

          optionClickVals.forEach(function (currentObject, objectIndex) {
            if (maxVal < +currentObject.value) {
              maxVal = +currentObject.value;
              optionResult = objectIndex;
              // If a and b, or b and c are clicked the same number of times,
              // or a and c are clicked the same number of times:
              if (mostlyABs || mostlyBCs) {
                answer = optionClickVals[1].option;
              } else if (mostlyACs) {
                answer = optionClickVals[0].option;
              } else {
                answer = optionResult + 1;
              }
            }
          });
        }

        ansBtn.on('click', function () {
          getAnswer();
          $(this)
            .closest(quizSection)
            .fadeOut()
            .prev()
            .find('.belle__quiz-ans-' + answer)
            .delay(550)
            .fadeIn();
        });

        restartBtn.on('click', function () {
          option1Val = option2Val = option3Val = 0;
          options.removeClass('active inactive button--dark').addClass('button--light');
          nextBtn.add(ansBtn).addClass('belle__quiz-btnInactive');
          quizSections.fadeOut();
          firstQ.fadeIn();
          $(this).closest(answerSection).fadeOut().parent().next().delay(400).fadeIn();
        });

        $(window).on('load', function () {
          // Content-Author-managed - Module Fade.
          if (moduleWillFade) {
            // Put in window load so that the page height is ready
            // by the time we get to animating.

            // Init scrollMagic Controller Class
            var controller = new ScrollMagic.Controller();
            var offset;

            // Set the offset.
            if ($thismodule.data('offset')) {
              offset = $thismodule.data('offset');
            } else {
              offset = 0;
            }

            // Init scrollMagic Scene Class
            var fadeThisModuleScene = new ScrollMagic.Scene({
              triggerElement: triggerMod,
              offset: offset
            }).on('start', function () {
              fadeThisModule();
            });

            controller.addScene([fadeThisModuleScene]);
          }
        });
      });
    }
  };
})(jQuery);
